<div class="carrito">
  <button mat-icon-button [disabled]="linkDisabled()" [routerLink]="'/carrito'">
    <mat-icon #carritoIcon>shopping_cart</mat-icon>
  </button>
  <div class="carrito-cantidad">
    <span [hidden]="!this.showCantidad">{{ cantidad }}</span>
  </div>
  <div class="floating-container">
    <div class="reference-element hidden"></div>
    <ng-container *ngIf="showCarritoPopUp()">
      <div class="floating-div">
        <div class="carrito-image-container">
          <img [src]="selectedImage(item)">
        </div>
        <div class="carrito-detalle-item">
          <mat-icon #closeIcon (click)="closePopup()">close</mat-icon>
          <ul>
            <li><span>{{ item?.title }}</span></li>
            <li><span>{{ item?.author }}</span></li>
            <li><span>{{ item?.price | currency: 'ARS':'symbol' }}</span><span>{{ ` x ${cantidadItem}` }}</span></li>
          </ul>
        </div>
      </div>
    </ng-container>
  </div>
</div>